/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    TIMED_ENTRY_CREATE_AVAILABILITY_ALERT,
    TIMED_ENTRY_CREATE_AVAILABILITY_ALERT_SUCCESS,
    TIMED_ENTRY_CREATE_AVAILABILITY_ALERT_ERROR,
    TIMED_ENTRY_GET_AVAILABILITY_ALERT_COUNTS,
    TIMED_ENTRY_GET_AVAILABILITY_ALERT_COUNTS_SUCCESS,
    TIMED_ENTRY_GET_AVAILABILITY_ALERT_COUNTS_ERROR,
    TIMED_ENTRY_GET_AVAILABILITY_ALERTS,
    TIMED_ENTRY_GET_AVAILABILITY_ALERTS_SUCCESS,
    TIMED_ENTRY_GET_AVAILABILITY_ALERTS_ERROR,
    TIMED_ENTRY_RESET_AVAILABILITY_ALERT,
} from '../actions/availabilityAlerts';

export const initialState = {
    availabilityAlerts: { alerts: [], status: 'IDLE', apiError: '' },
    availabilityAlert: { status: 'IDLE', apiError: '' },
    availabilityAlertsCount: { status: 'IDLE', apiError: '' },
};

export const availabilityAlertsReducers = (state = initialState, action) => {
    switch (action.type) {
        case TIMED_ENTRY_CREATE_AVAILABILITY_ALERT:
            return {
                ...state,
                availabilityAlert: {
                    ...state.availabilityAlert,
                    status: 'LOADING',
                    apiError: '',
                },
            };
        case TIMED_ENTRY_CREATE_AVAILABILITY_ALERT_SUCCESS:
            return {
                ...state,
                availabilityAlert: {
                    ...state.availabilityAlert,
                    ...action.payload,
                    status: 'SUCCESS',
                    apiError: '',
                },
            };
        case TIMED_ENTRY_CREATE_AVAILABILITY_ALERT_ERROR: {
            return {
                ...state,
                availabilityAlert: {
                    ...state.availabilityAlert,
                    status: 'ERROR',
                    apiError:
                        action.payload ||
                        'There is a problem in trying to create your alert.',
                },
            };
        }
        case TIMED_ENTRY_GET_AVAILABILITY_ALERT_COUNTS: {
            return {
                ...state,
                availabilityAlertsCount: {
                    ...state.availabilityAlertsCount,
                    status: 'LOADING',
                    apiError: '',
                },
            };
        }

        case TIMED_ENTRY_GET_AVAILABILITY_ALERT_COUNTS_SUCCESS: {
            return {
                ...state,
                availabilityAlertsCount: {
                    ...state.availabilityAlertsCount,
                    ...action.payload,
                    status: 'SUCCESS',
                    apiError: '',
                },
            };
        }
        case TIMED_ENTRY_GET_AVAILABILITY_ALERT_COUNTS_ERROR: {
            return {
                ...state,
                availabilityAlertsCount: {
                    ...state.availabilityAlertsCount,
                    status: 'ERROR',
                    apiError:
                        action.payload ||
                        'There is a problem in retrieving availability alert information',
                },
            };
        }

        case TIMED_ENTRY_GET_AVAILABILITY_ALERTS: {
            return {
                ...state,
                availabilityAlerts: {
                    ...state.availabilityAlerts,
                    alerts: [],
                    status: 'LOADING',
                    apiError: '',
                },
            };
        }

        case TIMED_ENTRY_GET_AVAILABILITY_ALERTS_SUCCESS: {
            return {
                ...state,
                availabilityAlerts: {
                    ...state.availabilityAlerts,
                    alerts: [...action.payload],
                    status: 'SUCCESS',
                    apiError: '',
                },
            };
        }
        case TIMED_ENTRY_GET_AVAILABILITY_ALERTS_ERROR: {
            return {
                ...state,
                availabilityAlerts: {
                    ...state.availabilityAlerts,
                    alerts: [],
                    status: 'ERROR',
                    apiError:
                        action.payload ||
                        'There is a problem in retrieving availability alerts information',
                },
            };
        }

        case TIMED_ENTRY_RESET_AVAILABILITY_ALERT: {
            return {
                ...state,
                availabilityAlert: {
                    ...initialState.availabilityAlerts,
                },
            };
        }

        default:
            return state;
    }
};
